<section class="jobs-section">
  <div class="jobs-container">
    <nav
      *ngIf="!isDashboard"
      class="flex items-center justify-between mb-4 md:mb-6 pb-3 md:pb-4 border-b border-slate-200"
    >
      <div class="flex items-center gap-4">
        <a routerLink="/" class="flex items-center">
          <img
            src="assets/images/BeExpert-logo (2).svg"
            alt="BeExpert"
            class="h-7 md:h-9 object-contain"
            onerror="this.src = 'assets/images/logo04.png'"
          />
        </a>
      </div>
      <div class="flex items-center gap-3">
        <button
          routerLink="/"
          class="text-sm font-medium text-slate-600 hover:text-indigo-600 transition hidden md:block"
        >
          Home
        </button>
        <button
          routerLink="/login"
          class="px-4 py-2 md:px-5 md:py-2.5 text-[13px] md:text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl shadow-sm transition-all ml-1 md:ml-2"
        >
          Login to Apply
        </button>
      </div>
    </nav>

    <div
      class="mb-4 md:mb-6 bg-white p-3.5 md:p-5 rounded-2xl md:rounded-[1.5rem] shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] border border-slate-100 relative overflow-hidden"
    >
      <div
        class="absolute top-0 right-0 -mr-16 -mt-16 w-48 h-48 rounded-full bg-indigo-50 blur-3xl opacity-60 pointer-events-none"
      ></div>

      <div class="relative z-10">
        <div class="flex flex-wrap items-center gap-4 mb-1">
          <button
            [routerLink]="isDashboard ? '/student-dashboard/home' : '/'"
            class="inline-flex items-center gap-1.5 px-3.5 py-1.5 text-sm font-semibold text-slate-600 bg-white border border-slate-200 rounded-xl shadow-sm hover:bg-slate-50 hover:text-indigo-600 hover:border-indigo-200 transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
            Back
          </button>
          <h2
            class="text-xl md:text-3xl font-black text-slate-900 tracking-tight"
          >
            All AI Interview <span class="brand-gradient-text">Openings</span>
          </h2>
        </div>
        <p
          class="text-slate-500 text-sm md:text-base font-medium max-w-2xl mb-3"
        >
          Browse every live AI Interview and start practicing in one click.
        </p>

        <div
          class="flex flex-col md:flex-row gap-3 bg-slate-50/80 p-1.5 rounded-xl border border-slate-200 backdrop-blur-sm"
        >
          <div class="relative flex-1">
            <svg
              class="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              ></path>
            </svg>
            <input
              type="text"
              placeholder="Search by role name..."
              [(ngModel)]="searchTerm"
              (input)="onSearchChange()"
              class="w-full h-11 md:h-10 pl-10 pr-4 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all"
            />
          </div>

          <div class="flex gap-3 w-full md:w-auto flex-wrap md:flex-nowrap">
            <div class="relative flex-1 md:min-w-[180px]">
              <select
                [(ngModel)]="selectedCategory"
                (change)="onCategoryChange()"
                class="w-full h-11 md:h-10 px-4 bg-white border border-slate-200 rounded-lg text-sm text-slate-700 focus:outline-none focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100 transition-all appearance-none cursor-pointer"
              >
                <option value="All">All Categories</option>
                <option value="Technical">Technical</option>
                <option value="Management">Management</option>
                <option value="General">General</option>
              </select>
              <svg
                class="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400 pointer-events-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                ></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!loading; else mockLoader">
      <div
        class="interview-card-grid"
        *ngIf="mockInterviews && mockInterviews.length > 0; else noMockData"
      >
        <div
          class="interview-card mock-interview-card"
          *ngFor="let interview of mockInterviews"
        >
          <div class="card-header">
            <div class="left-section">
              <div class="company-logo-wrap">
                <img
                  *ngIf="interview.practice_company_logo"
                  [src]="interview.practice_company_logo"
                  (error)="interview.practice_company_logo = null"
                  [alt]="interview.practice_company_name || 'Company'"
                />
                <div
                  *ngIf="!interview.practice_company_logo"
                  class="company-logo-placeholder"
                >
                {{ interview.practice_company_name?.charAt(0)?.toUpperCase() || '?' }}
                </div>
              </div>

              <div class="title-section">
                <h3 class="role-title" [title]="interview.job_role">
                  {{ interview.job_role }}
                </h3>
                <span
                  class="company-name"
                  [title]="interview.practice_company_name"
                >
                  {{ interview.practice_company_name || "Practice Interview" }}
                </span>
              </div>
            </div>

            <span
              class="category-pill"
              [class.technical]="
                interview.interview_category?.toLowerCase() === 'technical'
              "
              [class.management]="
                interview.interview_category?.toLowerCase() === 'management'
              "
              *ngIf="interview.interview_category"
            >
              {{ interview.interview_category }}
            </span>
          </div>

          <div class="card-body">
            <div class="meta-row">
              <div class="meta-item">
                <div class="meta-icon video-icon">
                  <i class="bi bi-camera-video"></i>
                </div>
                <span class="meta-text">AI Interview</span>
              </div>

              <div class="meta-item">
                <div class="meta-icon time-icon">
                  <i class="bi bi-clock"></i>
                </div>
                <span class="meta-text"
                  >{{ interview.total_duration_minutes || 0 }} Minutes</span
                >
              </div>
            </div>

            <button
              class="start-mock-btn"
              (click)="startMockInterview(interview.id)"
            >
              <span>Start Mock Interview</span>
              <i class="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <ng-template #noMockData>
        <div class="no-data-container">
          <i class="bi bi-clipboard-x"></i>
          <p *ngIf="searchTerm || selectedCategory !== 'All'">
            No practice interviews found matching your search or filter.
          </p>
          <p *ngIf="!searchTerm && selectedCategory === 'All'">
            No practice interviews available at this time.
          </p>
          <button
            class="clear-filter-btn"
            *ngIf="searchTerm || selectedCategory !== 'All'"
            (click)="clearFilters()"
          >
            <i class="bi bi-x-circle"></i> Clear Filters
          </button>
        </div>
      </ng-template>
      <div
        class="flex justify-center mt-12 mb-8"
        *ngIf="mockInterviews.length > 0 && hasMore"
      >
        <button
          class="px-6 py-3 text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 rounded-xl shadow-sm transition-all flex items-center justify-center disabled:opacity-70 disabled:bg-slate-400 disabled:cursor-not-allowed group"
          (click)="loadMore()"
          [disabled]="isLoadingMore"
        >
          <ng-container *ngIf="!isLoadingMore">
            Load More Mock Interviews
            <svg
              class="w-4 h-4 ml-2 transition-transform group-hover:translate-y-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
          </svg>
          </ng-container>
          <ng-container *ngIf="isLoadingMore">
            <div
              class="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"
            ></div>
            Loading...
          </ng-container>
        </button>
      </div>
    </div>

    <ng-template #mockLoader>
      <div class="interview-card-grid skeleton-grid">
        <div
          class="interview-card skeleton-card"
          *ngFor="let s of [1, 2, 3, 4, 5, 6]"
        >
          <div class="card-header">
            <div class="left-section">
              <div class="company-logo-wrap skeleton-circle"></div>
              <div class="title-section">
                <div class="skeleton-line w-70"></div>
                <div class="skeleton-line w-40"></div>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="flex gap-3 mb-3">
              <div class="skeleton-line w-30 mb-0"></div>
              <div class="skeleton-line w-30 mb-0"></div>
            </div>
            <div class="skeleton-btn"></div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</section>
